import { ProjectManagementStatus } from '@round/api';
import styles from './ProjectStatusSelect.module.css';
import { getValue, projectStatusMeta, ProjectStatusOption } from './helpers';
import { OptionProps, components as selectComponents, SingleValueProps } from 'react-select';
import cn from 'classnames';

type Props = { status: ProjectManagementStatus; className?: string };

const ProjectStatusLabel = ({ status, className }: Props) => {
    const statusMeta = projectStatusMeta[status];

    return (
        <div className={cn(styles.option, className)}>
            <span className={styles.dot} style={{ backgroundColor: statusMeta.color }} />
            {statusMeta.label}
        </div>
    );
};

export const Option = (props: OptionProps<ProjectStatusOption, false>) => {
    return (
        <selectComponents.Option {...props}>
            <ProjectStatusLabel status={props.data.value} />
        </selectComponents.Option>
    );
};

export const SingleValue = (props: SingleValueProps<ProjectStatusOption>) => {
    const value = getValue(props.getValue());
    if (!value) {
        return null;
    }

    return (
        <selectComponents.SingleValue {...props}>
            <ProjectStatusLabel status={value.value} />
        </selectComponents.SingleValue>
    );
};
